import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_Interface, Empty_Calibration_Interface, } from 'src/app/Interface/Calibration_Interface';
import { DataEntity_Detail_07_Interface, Empty_DataEntity_Detail_07_Interface } from 'src/app/Interface/DataEntity/07/DataEntity_Detail_07_Interface';
import { DataEntity_Main_07_Interface, Empty_DataEntity_Main_07_Interface } from 'src/app/Interface/DataEntity/07/DataEntity_Main_07_Interface';
import { DataEntity_Working_07_Interface, Empty_DataEntity_Working_07_Interface } from 'src/app/Interface/DataEntity/07/DataEntity_Working_07_Interface';
import { DataEntity_Resolution_07_Interface, Empty_DataEntity_Resolution_07_Interface } from 'src/app/Interface/DataEntity/07/DataEntity_Resolution_07_Interface';
import { Device_MPE_Interface } from 'src/app/Interface/Device_MPE_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Unit_Interface } from 'src/app/Interface/Unit_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { DataEntity07Service } from 'src/app/Service/DataEntity/07/DataEntity07.service';
import { DataEntityMainService } from 'src/app/Service/DataEntity/DataEntityMain.service';
import { UnitService } from 'src/app/Service/Unit/Unit.service';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-DataEntity07',
  templateUrl: './DataEntity07.component.html',
  styleUrls: ['./DataEntity07.component.css']
})
export class DataEntity07Component implements OnInit {

  constructor(
    private Calibration_Service: CalibrationService,
    private DataEntity07_Service: DataEntity07Service,
    private DataEntityMain_Service: DataEntityMainService,
    private Alerify_Service: AlertifyService,
    private Unit_Service: UnitService,
    private modalService: BsModalService,
    private route: ActivatedRoute
  ) { }
  FileName: string = '';
  FolderName: string = '';
  MappingFile: string = '';
  Capability: string = '';

  CertificateCode: String = '';
  CertificateUrlPdf: string = ''

  Manufacture_txt: String = '';
  Type_txt: String = '';
  Model_txt: String = '';


  DataEntity_Id: number = 10;


  InProccessing: boolean = false;
  Calibration_Device_Id: number = 0;

  Calibration_Id: number = 0;
  Observation: number = 0;

  unit_reference: string = ''
  unit_indication: string = ''
  unit_error: string = ''
  unit_correction: string = ''
  unit_uncertainty: string = ''
  unit_working: string = ''
  unit_repeatability: string = ''
  unit_eccentricity: string = ''



  before_from: string = ''
  before_to: string = ''
  before_method: string = ''



  ngOnInit() {

    this.MainFormDataEntity = new FormGroup({
      id: new FormControl(),

      Temperature_Air_before: new FormControl(null, [Validators.required]),
      Temperature_Air_after: new FormControl(null, [Validators.required]),

      Humidity_Air_before: new FormControl(null, [Validators.required]),
      Humidity_Air_after: new FormControl(null, [Validators.required]),

      Pressure_before: new FormControl(null, [Validators.required]),
      Pressure_after: new FormControl(null, [Validators.required]),
    });

    this.ResolutionFormDataEntity = new FormGroup({
      capacity: new FormControl(''),
      unit: new FormControl(''),
      scale: new FormControl(null, [Validators.required]),
    });



    this.ResolutionFormDataEntity_Working = new FormGroup({
      max_value: new FormControl(null, [Validators.required]),
      min_value: new FormControl(null, [Validators.required]),
    });

    this.Calibration_Device_Id = Number(this.route.snapshot.paramMap.get('id'));
    this.OnIntial();
  }

  OnIntial() {
    this.DataEntity07_Service.GetSingle(this.Calibration_Device_Id, this.DataEntity_Id).subscribe(
      (data) => {
        if (data['result'] != null) {



          var temp: DataEntity_Main_07_Interface = Empty_DataEntity_Main_07_Interface();
          this.Observation = data['observation'];

          this.DataList_Resolution = data['resolution'];
          this.DataList_Resolution_Working = data['working'];




          this.Nominal_Value_List = []
          this.Nominal_Value_List_01 = []

          temp = data['result'];
          this.Calibration_Id = temp.id;
          this.FileName = temp.filename;
          this.FolderName = temp.pdf_src;
          this.MappingFile = temp.mapping;
          this.Capability = temp.capability;

          this.unit_working = temp.unit_working;
          this.unit_reference = temp.unit_reference;
          this.unit_indication = temp.unit_indication;
          this.unit_error = temp.unit_error;
          this.unit_correction = temp.unit_correction;
          this.unit_uncertainty = temp.unit_uncertainty;
          this.unit_eccentricity = temp.unit_eccentricity;
          this.unit_repeatability = temp.unit_repeatability;



          this.before_from = temp.before_from;
          this.before_to = temp.before_to;
          this.before_method = temp.before_method;





          this.Manufacture_txt = temp.manufacture;
          this.Type_txt = temp.type;
          this.Model_txt = temp.model;

          if (data['certificateUrl'])
            this.CertificateUrlPdf = environment.BaseUrl + data['certificateUrl']
          else
            this.CertificateUrlPdf = ""



          this.get_Form_Temperature_Air_before().setValue(temp['temperature_Air_before']);
          this.get_Form_Temperature_Air_after().setValue(temp['temperature_Air_after']);

          this.get_Form_Humidity_Air_before().setValue(temp['humidity_Air_before']);
          this.get_Form_Humidity_Air_after().setValue(temp['humidity_Air_after']);

          this.get_Form_Pressure_before().setValue(temp['pressure_before']);
          this.get_Form_Pressure_after().setValue(temp['pressure_after']);



          for (let item of data['detail']) {
            var tempDetail: DataEntity_Detail_07_Interface = Empty_DataEntity_Detail_07_Interface();

            tempDetail.reference = item['reference']
            tempDetail.indication = item['indication']
            tempDetail.error = item['error']
            tempDetail.repeatability = item['repeatability']
            tempDetail.eccentricity = item['eccentricity']

            tempDetail.uncertainty = item['uncertainty']
            tempDetail.converage = item['converage']

            this.Nominal_Value_List.push(tempDetail)

          }
        }
        this.Read_Unit()
        this.CertificateCode = data['certificate_Code'];
      },
      (error) => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }

  //#region Main Data Entity

  Nominal_Value_List: Array<DataEntity_Detail_07_Interface> = [];
  Nominal_Value_List_01: Array<DataEntity_Detail_07_Interface> = [];
  temp_Nominal_Value_List: Array<DataEntity_Detail_07_Interface> = [];
  MainFormDataEntity: FormGroup;

  get_Form_Temperature_Air_before() {
    return this.MainFormDataEntity.get('Temperature_Air_before') as FormControl;
  }
  get_Form_Temperature_Air_after() {
    return this.MainFormDataEntity.get('Temperature_Air_after') as FormControl;
  }

  get_Form_Humidity_Air_before() {
    return this.MainFormDataEntity.get('Humidity_Air_before') as FormControl;
  }
  get_Form_Humidity_Air_after() {
    return this.MainFormDataEntity.get('Humidity_Air_after') as FormControl;
  }

  get_Form_Pressure_before() {
    return this.MainFormDataEntity.get('Pressure_before') as FormControl;
  }
  get_Form_Pressure_after() {
    return this.MainFormDataEntity.get('Pressure_after') as FormControl;
  }


  //#endregion

  //#region Upload

  Procssing_Import: boolean = false
  upload_file_excel(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.Procssing_Import = true

    this.DataEntity07_Service.uploadFile(formData).subscribe(
      data => {
        this.Procssing_Import = false
        if (data['dsc']) {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else {
          this.Nominal_Value_List = []
          this.Alerify_Service.SuccessMessage("اطلاعات خوانده شد")

          this.FileName = data['filename']
          this.Capability = data['capability']

          for (let item of data['nominal']) {
            var temp: DataEntity_Detail_07_Interface = Empty_DataEntity_Detail_07_Interface()

            temp.reference = item['reference']
            temp.indication = item['indication']
            temp.error = item['error']
            temp.repeatability = item['repeatability']
            temp.eccentricity = item['eccentricity']

            temp.uncertainty = item['uncertainty']
            temp.converage = item['converage']

            this.Nominal_Value_List.push(temp)

          }
        }
      }
    )

  }

  Procssing_Import2: boolean = false
  upload_file_pdf(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.Procssing_Import2 = true

    this.DataEntity07_Service.uploadPdf(formData).subscribe(
      data => {
        this.Procssing_Import2 = false
        if (data['filename']) {
          this.Alerify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alerify_Service.SuccessMessage("اطلاعات خوانده شد")
          this.FolderName = data['fodlername']

        }
      }
    )

  }

  //#endregion

  //#region Unit
  modalRef_Unit:any
  DataList_Unit: Array<Unit_Interface> = []
  Read_Unit() {
    this.Unit_Service.GetDataEntity(this.DataEntity_Id).subscribe(
      data => {
        this.DataList_Unit = data
      },
      (error) => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }


  Selected_Unit:string=''

  OnUserSetUnit(index:Number,template: TemplateRef<any>){
    if(!this.unit_reference && index!=1)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_indication && index!=2)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_error && index!=3)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_correction && index!=4)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_uncertainty && index!=5)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_working && index!=6)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_repeatability && index!=7)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_eccentricity && index!=8)
      this.Set_Selected_Unit(index,template)
  }

  Set_Selected_Unit(index:Number,template: TemplateRef<any>){
    if(index==1)
      this.Selected_Unit=this.unit_reference
    else if(index==2)
      this.Selected_Unit=this.unit_indication
    else if(index==3)
      this.Selected_Unit=this.unit_error
    else if(index==4)
      this.Selected_Unit=this.unit_correction
    else if(index==5)
      this.Selected_Unit=this.unit_uncertainty
    else if(index==6)
      this.Selected_Unit=this.unit_working
    else if(index==7)
      this.Selected_Unit=this.unit_repeatability
    else if(index==8)
      this.Selected_Unit=this.unit_eccentricity

    if(this.Selected_Unit)
      this.modalRef_Unit = this.modalService.show(template);
  }

  SetToAllUnit(){
    if(!this.unit_reference)
      this.unit_reference=this.Selected_Unit

    if(!this.unit_indication)
      this.unit_indication=this.Selected_Unit

    if(!this.unit_error)
      this.unit_error=this.Selected_Unit

    if(!this.unit_correction)
      this.unit_correction=this.Selected_Unit

    if(!this.unit_uncertainty)
      this.unit_uncertainty=this.Selected_Unit

    if(!this.unit_working)
      this.unit_working=this.Selected_Unit

    if(!this.unit_repeatability)
      this.unit_repeatability=this.Selected_Unit

    if(!this.unit_eccentricity)
      this.unit_eccentricity=this.Selected_Unit

    this.modalRef_Unit.hide()
  }

  //#endregion

  //#region Resolution 
  ResolutionFormDataEntity: FormGroup;
  DataList_Resolution: Array<DataEntity_Resolution_07_Interface> = []
  temp_DataList_Resolution: Array<DataEntity_Resolution_07_Interface> = []

  Delete_Resolution(id: number) {
    this.DataList_Resolution.splice(id, 1)
    this.Alerify_Service.SuccessMessage("حذف شد")
  }

  Add_Resolution() {

    var temp_DataList_Resolution: Array<DataEntity_Resolution_07_Interface> = []
    temp_DataList_Resolution = this.DataList_Resolution


    var CanAdd: Boolean = true
    for (let item of temp_DataList_Resolution) {
      if (Number(item.capacity) == Number(this.get_Form_capacity().value)) {
        CanAdd = false
        break;
      }
    }

    if (temp_DataList_Resolution.length >= 7) {
      this.Alerify_Service.ErrorMessage("حداکثر ۷ مورد رنج و رزلوشن می تواند ثبت کرد!")
    }
    else if (CanAdd) {

      var temp: DataEntity_Resolution_07_Interface = Empty_DataEntity_Resolution_07_Interface()
      temp.capacity = this.get_Form_capacity().value + ''
      temp.unit = this.get_Form_unit().value + ''
      temp.scale = this.get_Form_scale().value + ''

      this.DataList_Resolution.push(temp)
      this.Alerify_Service.SuccessMessage("اطلاعات ثبت شد")
    }
    else {
      this.Alerify_Service.ErrorMessage("اطلاعات جدید با اطلاعات موجود همپوشانی دارد")
    }
  }


  get_Form_capacity() {
    return this.ResolutionFormDataEntity.get('capacity') as FormControl;
  }

  get_Form_unit() {
    return this.ResolutionFormDataEntity.get('unit') as FormControl;
  }

  get_Form_scale() {
    return this.ResolutionFormDataEntity.get('scale') as FormControl;
  }

  //#endregion

  //#region Resolution Working
  ResolutionFormDataEntity_Working: FormGroup;
  DataList_Resolution_Working: Array<DataEntity_Working_07_Interface> = []

  Delete_Resolution_Working(id: number) {
    this.DataList_Resolution_Working.splice(id, 1)
    this.Alerify_Service.SuccessMessage("حذف شد")
  }

  Add_Resolution_Working() {

    if (this.DataList_Resolution_Working.length >= 70) {
      this.Alerify_Service.ErrorMessage("حداکثر 70 مورد working می تواند ثبت کرد!")
    }
    else {

      var temp: DataEntity_Working_07_Interface = Empty_DataEntity_Working_07_Interface()
      temp.max_value = this.get_Form_Working_max_value().value + ''
      temp.min_value = this.get_Form_Working_min_value().value + ''
      this.DataList_Resolution_Working.push(temp)
      this.Alerify_Service.SuccessMessage("اطلاعات ثبت شد")
    }
  }


  get_Form_Working_max_value() {
    return this.ResolutionFormDataEntity_Working.get('max_value') as FormControl;
  }

  get_Form_Working_min_value() {
    return this.ResolutionFormDataEntity_Working.get('min_value') as FormControl;
  }


  //#endregion

  //#region LabAddress

  Set_LabAddress_click(input: string) {
    this.Calibration_Device.labAdderss = input

  }

  //#endregion


  //#region Calibration
  Calibration_Device: Calibration_Interface = Empty_Calibration_Interface();
  Set_CalibrationDeviceInfo_click(input: Calibration_Interface) {
    this.Calibration_Device = input
  }

  //#endregion

  modalRef_CodeSerial: any;
  modalRef_CodeSerial_Title: any;
  modalRef_Code: any;

  onSubmit(template: TemplateRef<any>, templateCodeSerial: TemplateRef<any>, id: number) {

    if ((!this.Calibration_Device.device_serial || !this.Calibration_Device.device_code || this.Calibration_Device.device_serial.trim() == "" || this.Calibration_Device.device_code.trim() == "") && id == 0) {
      this.modalRef_CodeSerial_Title = "مقدار سریال یا کد دستگاه  ثبت نشده است "
      this.modalRef_CodeSerial = this.modalService.show(templateCodeSerial);
    }
    else if ((!this.Model_txt || this.Model_txt.trim() == "") && id == 0) {
      this.modalRef_CodeSerial_Title = "مقدار MODEL  ثبت نشده است "
      this.modalRef_CodeSerial = this.modalService.show(templateCodeSerial);
    }

    else {
      this.InProccessing = true;
      var temp: DataEntity_Main_07_Interface = Empty_DataEntity_Main_07_Interface();

      temp.id = this.Calibration_Id;

      temp.unit_working = this.unit_working;
      temp.unit_reference = this.unit_reference;
      temp.unit_indication = this.unit_indication;
      temp.unit_error = this.unit_error;
      temp.unit_correction = this.unit_correction;
      temp.unit_uncertainty = this.unit_uncertainty;
      temp.unit_eccentricity = this.unit_eccentricity;
      temp.unit_repeatability = this.unit_repeatability;

      temp.before_from = this.before_from;
      temp.before_method = this.before_method;
      temp.before_to = this.before_to;
      temp.mapping = this.MappingFile;


      temp.temperature_Air_before = this.get_Form_Temperature_Air_before().value;
      temp.temperature_Air_after = this.get_Form_Temperature_Air_after().value;

      temp.humidity_Air_before = this.get_Form_Humidity_Air_before().value;
      temp.humidity_Air_after = this.get_Form_Humidity_Air_after().value;

      temp.pressure_before = this.get_Form_Pressure_before().value;
      temp.pressure_after = this.get_Form_Pressure_after().value;





      this.temp_DataList_Resolution = []
      for (let item of this.DataList_Resolution) {
        this.temp_DataList_Resolution.push(item)
      }

      this.temp_Nominal_Value_List = []
      for (let item of this.Nominal_Value_List) {
        this.temp_Nominal_Value_List.push(item)
      }

      for (let item of this.Nominal_Value_List_01) {
        this.temp_Nominal_Value_List.push(item)
      }

      this.DataEntity07_Service.Submit(
        temp,
        this.temp_Nominal_Value_List,
        this.temp_DataList_Resolution,
        this.DataList_Resolution_Working,
        this.DataEntity_Id,
        this.Calibration_Device_Id,
        this.FileName,
        this.FolderName,
        this.Capability,
        this.Calibration_Device.device_serial,
        this.Calibration_Device.device_code,
        this.Manufacture_txt,
        this.Type_txt,
        this.Model_txt,
        this.Calibration_Device.labAdderss).subscribe((data) => {
        this.InProccessing = false;
        if (data['id'] == -1) {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else if (data['certificate_Code'] == '') {
          this.Alerify_Service.ErrorMessage('خطا سیستمی');
        } else {
          this.CertificateCode = data['certificate_Code'];
          this.Alerify_Service.SuccessMessage('اطلاعات ثبت شد');

          this.OnIntial()

          if (data['certificateUrl'])
            this.CertificateUrlPdf = environment.BaseUrl + data['certificateUrl']
          else
            this.CertificateUrlPdf = ""

          this.modalRef_Code = this.modalService.show(template);
        }
      });

    }
  }

  onSubmit_Code(template: TemplateRef<any>, templateCodeSerial: TemplateRef<any>, id: number) {
    this.onSubmit(template, templateCodeSerial, 1)
    this.modalRef_CodeSerial.hide()
  }

  Set_Mapping_Str(input: string) {
    this.MappingFile = input
  }


}
